export default function AboutStory() {
  return (
    <section className="py-32 bg-[#0F2744]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Our Vision */}
        <div className="mb-32">
          <h3 className="text-5xl font-serif font-bold text-center text-white mb-20">Our Vision</h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {/* Standard */}
            <div className="group bg-[#0A1628] rounded-2xl p-8 border border-[#D4AF37]/20 hover:border-[#D4AF37] transition-all">
              <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center">
                <i className="ri-compass-3-line text-5xl text-[#D4AF37] group-hover:scale-110 transition-transform"></i>
              </div>
              <h4 className="text-2xl font-bold text-white mb-4 text-center">Standard</h4>
              <p className="text-lg text-[#D4AF37] mb-4 text-center font-medium">더 나은 삶을 위한 기준</p>
              <p className="text-gray-300 leading-relaxed text-center">
                무엇을 읽느냐가 당신의 관점을 결정합니다. 정보의 홍수 속에서 삶의 중심을 잡아줄 단단한 나침반이 되어줄 책을 만듭니다.
              </p>
            </div>

            {/* Meaningful Point */}
            <div className="group bg-[#0A1628] rounded-2xl p-8 border border-[#D4AF37]/20 hover:border-[#D4AF37] transition-all">
              <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center">
                <i className="ri-focus-3-line text-5xl text-[#D4AF37] group-hover:scale-110 transition-transform"></i>
              </div>
              <h4 className="text-2xl font-bold text-white mb-4 text-center">Meaningful Point</h4>
              <p className="text-lg text-[#D4AF37] mb-4 text-center font-medium">혼란 속의 명확한 한 점</p>
              <p className="text-gray-300 leading-relaxed text-center">
                복잡하게 얽힌 고민들 사이에서 의미 있는 발견을 이끌어냅니다. 방황하던 생각들이 하나의 확신으로 연결되는 점을 찍어드립니다.
              </p>
            </div>

            {/* Connection */}
            <div className="group bg-[#0A1628] rounded-2xl p-8 border border-[#D4AF37]/20 hover:border-[#D4AF37] transition-all">
              <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center">
                <i className="ri-links-line text-5xl text-[#D4AF37] group-hover:scale-110 transition-transform"></i>
              </div>
              <h4 className="text-2xl font-bold text-white mb-4 text-center">Connection</h4>
              <p className="text-lg text-[#D4AF37] mb-4 text-center font-medium">깊은 신뢰로 잇는 마음</p>
              <p className="text-gray-300 leading-relaxed text-center">
                책은 저자의 진심과 독자의 성장이 만나는 지점입니다. 우리는 그 사이를 견고한 신뢰로 연결하는 가장 믿음직한 가교가 되겠습니다.
              </p>
            </div>
          </div>
        </div>

        {/* Our Publishing Philosophy */}
        <div id="philosophy" className="bg-gradient-to-br from-[#1A2F4A] to-[#0A1628] rounded-3xl p-16 border border-[#D4AF37]/20">
          <h3 className="text-4xl font-serif font-bold text-center text-white mb-8">
            Our Publishing Philosophy
          </h3>
          <p className="text-center text-lg text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
            어떤 책을 지향하는지 구체적으로 보여드립니다.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
            {/* 기준을 주는 책 */}
            <div className="bg-[#0A1628] rounded-2xl p-8 hover:shadow-2xl transition-all border border-[#D4AF37]/20 hover:border-[#D4AF37] flex flex-col h-full">
              <div className="w-16 h-16 bg-[#D4AF37]/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-ruler-line text-3xl text-[#D4AF37]"></i>
              </div>
              <h4 className="text-xl font-bold text-white mb-3">기준을 주는 책</h4>
              <p className="text-sm text-[#D4AF37] mb-4 font-medium">The Standard</p>
              <p className="text-gray-300 leading-relaxed flex-grow">
                정보의 홍수 속에서 올바른 방향을 제시합니다. 흔들리지 않는 나만의 철학을 세울 수 있도록 돕겠습니다.
              </p>
            </div>

            {/* 시작점을 선물하는 책 */}
            <div className="bg-[#0A1628] rounded-2xl p-8 hover:shadow-2xl transition-all border border-[#D4AF37]/20 hover:border-[#D4AF37] flex flex-col h-full">
              <div className="w-16 h-16 bg-[#D4AF37]/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-rocket-line text-3xl text-[#D4AF37]"></i>
              </div>
              <h4 className="text-xl font-bold text-white mb-3">시작점을 선물하는 책</h4>
              <p className="text-sm text-[#D4AF37] mb-4 font-medium">The Start</p>
              <p className="text-gray-300 leading-relaxed flex-grow">
                첫 페이지를 넘기는 순간, 망설임은 용기로 변합니다. 당신의 새로운 챕터를 여는 가장 다정한 계기가 되겠습니다.
              </p>
            </div>

            {/* 의미 있는 마침표를 찍어주는 책 */}
            <div className="bg-[#0A1628] rounded-2xl p-8 hover:shadow-2xl transition-all border border-[#D4AF37]/20 hover:border-[#D4AF37] flex flex-col h-full">
              <div className="w-16 h-16 bg-[#D4AF37]/10 rounded-full flex items-center justify-center mb-6">
                <i className="ri-checkbox-circle-line text-3xl text-[#D4AF37]"></i>
              </div>
              <h4 className="text-xl font-bold text-white mb-3">의미 있는 마침표를 찍어주는 책</h4>
              <p className="text-sm text-[#D4AF37] mb-4 font-medium">The Period</p>
              <p className="text-gray-300 leading-relaxed flex-grow">
                수많은 물음표를 명쾌한 마침표로 바꾸는 시간. 깊은 사유 끝에 완성된 깨달음을 한 권의 책에 담습니다.
              </p>
            </div>
          </div>

          {/* Cr.edit이 만들고자 하는 책 */}
          <div className="bg-[#0A1628] rounded-2xl p-8 border border-[#D4AF37]/30">
            <h4 className="text-2xl font-bold text-white mb-4 text-center">Cr.edit이 만들고자 하는 책</h4>
            <p className="text-gray-300 leading-relaxed text-center text-lg">
              Cr.edit은 단순한 정보가 아닌, 독자의 삶을 바꾸는 '계기'를 만드는 책에 집중합니다.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
